import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas";
import ReduxDevTools from "../components/ReduxDevTools";

const sagaMiddleware = createSagaMiddleware();

export default function configureStore() {
  const store = createStore(
    rootReducer,
    compose(applyMiddleware(sagaMiddleware), ReduxDevTools.instrument())
  );
  sagaMiddleware.run(rootSaga);

  return store;
}
